import React, { useState } from 'react';

const FileUpload = ({ authToken }) => {
  const [file, setFile] = useState(null);
  const [isUploadButtonDisabled, setIsUploadButtonDisabled] = useState(false);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      alert('Please select a file first!');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      setIsUploadButtonDisabled(true);

      const url = process.env.REACT_APP_BASE_API_URL + 'Menu';

      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': authToken,
          // 'Content-Type': 'multipart/form-data' is not required with fetch when using FormData
        },
      });

      if (!response.ok) {
        //show error message
        const errorText = await response.text();
        alert(`File upload failed. 
          Not all products were uploaded. 
          Please check the input file and try again. 
          If the problem persists, contact the system administrator.
          ${errorText}`);
        setIsUploadButtonDisabled(false);
        throw new Error('File upload failed');
      }
      else {
        //show success message
        alert('File uploaded successfully');
        setIsUploadButtonDisabled(false);
      }

      const data = await response.json();
      console.log('File uploaded successfully', data);
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  return (
    <div>
      <div>
        <button className="btn btn-info" style={{ position: 'absolute', right: 25, top: 25 }} onClick={toLogin}>Return</button>
      </div>
      <div>
        <h1>Upload a config file with Product Data</h1>
        <p>
          Select a csv file to upload. The file should contain product data in the following format:<br></br>
          productNumber;productName;categories;price;type;brouwer;outOfStock;description<br></br>
          2;BRUGSE BLOND;A. Van het vat, D. Uitgelicht;3;Blond;De Halve maan  ;False;Brugse is een goudblond bier met een rijke schuimkraag en een fruitig aroma. &lt;/br&gt; Etc...<br></br>
        </p>
        <p>
          Following fields are mandatory:<br></br>
          <ul>
            <li>productNumber should be a unique number for each product.</li>
            <li>productName is the name of the product.</li>
            <li>categories should be a comma separated list of categories. They automatically become search options in the store</li>
            <li>price is the price of the product expressed as a decimal using a point '.' notation (eg 1.50 or 3.25 ).</li>
            <li>outOfStock is a boolean value indicating if the product is out of stock.</li>
            <li>description is a description of the product. <b> Do not use semicolons (;) or linebreaks/enters in a basic text editor as they will break the upload, to start a new line, use &lt;/br&gt; instead! </b> or use this webtool to excel to edit the text.</li>
          </ul>
          Following fields are optional:<br></br>
          <ul>
            <li>type is the type of the product. It's a search option in the store. It is mostly used to specify the kind of beer (eg Blond, Donker, ...)</li>
            <li>brouwer is the name of the brewery. Currently not used in the app, may be left blank.</li>
          </ul>
          An example file can be downloaded here: <a href="./Bierlijst example.csv">Example file</a>
        </p>
      </div>
      <div className="container mt-5">
        <form onSubmit={handleSubmit} className="form-inline">
          <div className="form-group mb-2">
            <input type="file" className="form-control" onChange={handleFileChange} />
          </div>
          <button type="submit" className="btn btn-primary mb-2" disabled={isUploadButtonDisabled}>
            {isUploadButtonDisabled ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {' '}Uploading...
              </>
            ) : 'Upload'}
          </button>
        </form>
      </div>
    </div >
  );
}

function toLogin() {
  window.location.href = '/login'; // Redirect to login page
}

export default FileUpload;